window._ = require('lodash')

window.bootstrap = require('bootstrap')

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery')

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';

// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     wsHost: process.env.MIX_WEBSOCKETS_HOST,
//     wsPort: process.env.MIX_WEBSOCKETS_PORT,
//     wssPort: process.env.MIX_WEBSOCKETS_PORT,
//     forceTLS: process.env.MIX_WEBSOCKETS_SCHEME === 'https',
//     enabledTransports: ['ws', 'wss'],
//     disableStats: true
// });

// window.Echo.channel('test-channel')
//     .listen('.TestEvent', (e) => {
//         console.log('Événement reçu:', e);
//         alert(e.message); // Affiche le message de l'événement
//     });
